import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

function TabArea(props:any){
  let myProps={
    isUpdate:false,
    active_tab:"write",
    onChangeTab:(tab_id:string)=>{},
    rowData:{},
    ...props
  };
  let user=useSelector((state:any) => state.user);
  let rowData=myProps.rowData;
  const [active_tab,set_active_tab] =useState(myProps.active_tab);
  const tabDataArr=[
    {id:"write",name:"정보"},
    {id:"section_video",name:"영상"},
    // {id:"section",name:"대단원"},
    // {id:"video",name:"영상"},
  ];

  let is_view_stu_tab=false;
  if(myProps.isUpdate){
    is_view_stu_tab=true;

    if(rowData.a_open_group=="main"){
      if(user.comp_seq!="4"){
        is_view_stu_tab=false;
      }
      if(rowData.mtextbook_use_arr&&rowData.mtextbook_use_arr.length>0){
        is_view_stu_tab=true;
      }
    }
  }

  if(is_view_stu_tab){
    tabDataArr.push({id:"student",name:"수강생"});
    tabDataArr.push( {id:"request",name:"신청서"});
  }

  const onChangeTab=(tab_id:string)=>{
    set_active_tab(tab_id);
    myProps.onChangeTab(tab_id);
  };

  let tabTags=tabDataArr.map((item:any,idx:number)=>{
    let active_class_name="";
    if(item.id==active_tab){
      active_class_name=" active";
    }
    return (
      <a className={"tab_list_item_a"+active_class_name} 
        key={idx} 
        onClick={()=>{onChangeTab(item.id);}} 
        >
        {item.name}
      </a>
    );
  });

  return (
    <div className="tab_list_wrap">
      {tabTags}
    </div>
  );
}

export default TabArea;